import { History, createBrowserHistory } from 'history';

let history: History;
let getAbsoluteUrl: (url: string) => string;

export const initHistory = (name: string) => {
  if (history) {
    throw new Error('initHistory called more than once');
  }
  history = createBrowserHistory();
  getAbsoluteUrl = (url: string) => `/designers/${name}/${url}`;
};

const PANELS = new Set(['productTypes', 'designs', 'upload']);
export const getRoute = (params: {
  panel?: string;
  designSearch?: string;
  isFreeEnabled?: string;
}) => {
  if (params.designSearch) {
    const searchParam = 'designs?searchTerm=' + params.designSearch;
    const isFreeParam = params.isFreeEnabled ? '&isFreeEnabled=' + params.isFreeEnabled : '';
    return searchParam + isFreeParam;
  } else if (params.panel && PANELS.has(params.panel)) {
    return params.panel;
  }
  return '';
};

export const navigate = (url: string, replace?: boolean) => {
  if (!history) {
    throw new Error('initHistory missing');
  }

  history[replace ? 'replace' : 'push'](getAbsoluteUrl(url));
};

export const getHistory = () => {
  if (!history) {
    throw new Error('initHistory missing');
  }
  return history;
};
